import { render } from "./CNPJSearch.vue?vue&type=template&id=eed3eb3e&scoped=true"
import script from "./CNPJSearch.vue?vue&type=script&lang=js"
export * from "./CNPJSearch.vue?vue&type=script&lang=js"

import "@/assets/styles.css?vue&type=style&index=0&lang=css&external"
import "./CNPJSearch.vue?vue&type=style&index=1&id=eed3eb3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eed3eb3e"]])

export default __exports__